import React from 'react';

import { IIconProps, TIconType } from '../interface';

const BagIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<g clipPath='url(#clip0_20693_70577)'>
				<path
					d='M8.25 6.75V20.25H3.75C3.55109 20.25 3.36032 20.171 3.21967 20.0303C3.07902 19.8897 3 19.6989 3 19.5V7.5C3 7.30109 3.07902 7.11032 3.21967 6.96967C3.36032 6.82902 3.55109 6.75 3.75 6.75H8.25Z'
					{...props ? { fill: 'currentColor' } : {}}
				/>
				<path
					d='M15.75 6.75V20.25H20.25C20.4489 20.25 20.6397 20.171 20.7803 20.0303C20.921 19.8897 21 19.6989 21 19.5V7.5C21 7.30109 20.921 7.11032 20.7803 6.96967C20.6397 6.82902 20.4489 6.75 20.25 6.75H15.75Z'
					{...props ? { fill: 'currentColor' } : {}}
				/>
				<path
					d='M20.25 6.75H3.75C3.33579 6.75 3 7.08579 3 7.5V19.5C3 19.9142 3.33579 20.25 3.75 20.25H20.25C20.6642 20.25 21 19.9142 21 19.5V7.5C21 7.08579 20.6642 6.75 20.25 6.75Z'
					{...props?.isActive ? { stroke: 'currentColor' } : { stroke: '#4D4DB3' }}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M15.75 20.25V5.25C15.75 4.85218 15.592 4.47064 15.3107 4.18934C15.0294 3.90804 14.6478 3.75 14.25 3.75H9.75C9.35218 3.75 8.97064 3.90804 8.68934 4.18934C8.40804 4.47064 8.25 4.85218 8.25 5.25V20.25'
					{...props?.isActive ? { stroke: 'currentColor' } : { stroke: '#4D4DB3' }}
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath id='clip0_20693_70577'>
					<rect
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default BagIcon;
